import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { TokenService } from '../services/token.service';

export const authGuard: CanActivateFn = (route, state) => {

  const router = inject(Router);
  const tokenService = inject(TokenService);

  const token = tokenService.getAccessToken();
  const user = tokenService.user;



  /* ❌ NOT LOGGED IN */
  if (!token) {
    router.navigate(['/auth/sign-in']);
    return false;
  }
  /* ✅ token exists but user missing → reload user from localStorage */
  if (!user) {
    return true; // allow — user will load from localStorage anyway
  }
  return true;
};

